import React, { useEffect } from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useSignup } from '../backend/Register'
import { useAuthContext } from '../backend/UseAuth'
import { getFirestore, doc, updateDoc } from "firebase/firestore";

export default function Home() {

    const navigate = useNavigate();

    const handleClick = (e) => {
        navigate("/contributions");
    }



    const { user } = useAuthContext()
    const [email, setEmail] = useState('');
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [password, setPassword] = useState('');
    const [educ, setEduc] = useState('');
    const [fluency2, setFluency] = useState('');
    const [language, setLanguage] = useState('');



    const [validationError, setValidationError] = useState(null)
    const [validationError2, setValidationError2] = useState(null)
    const { signup, error } = useSignup()
    const { login, error2 } = useSignup()
    const handleSubmit = (e) => {
        e.preventDefault();

        if (!firstname || !lastname) {
            setValidationError('Name cannot be empty')
            return
        }

        else if (!email) {
            setValidationError('Email cannot be empty')
            return
        }
        else if (!password) {
            setValidationError('Password cannot be empty')
            return
        }


        setValidationError(null)
        console.log({ email, password, firstname, lastname })
        signup({ email, password, firstname, lastname })



    }
    const handleSubmit2 = (e) => {
        e.preventDefault()

        if (!email) {
            setValidationError2('Email cannot be empty')
            return
        }
        else if (!password) {
            setValidationError2('Password cannot be empty')
            return
        }

        setValidationError2(null)
        console.log({ email, password })
        login({ email, password })


    }

    const handleSubmit3 = (e) => {
        e.preventDefault();

        const db = getFirestore();

        const docRef = doc(db, "users", user.uid);

        const data = {
            educattainment: educ,
            fluency: fluency2,
            languagespoken: language
        };

        updateDoc(docRef, data)
            .then(docRef => {
                console.log("A New Document Field has been added to an existing document");
                <Link to="/contributions"></Link>
            })
            .catch(error => {
                console.log(error);
            })

    }
    return (





        <React.Fragment>



            <div className="overlay"></div>



            <div className="body-wrapper bg--accent min-vh-100 overflow-hidden d-flex align-items-center  position-relative" id="mainbody">

                <div className="header">
                    <div className="header-bottom">
                        <div className="header-bottom-area align-items-center">
                            <div className="logo"><Link to="/"><img src="assets/images/logo.png" alt="logo" /></Link></div>
                            <ul className="menu">
                                <li>{
                                    <Link to="/">Home</Link>
                                }

                                </li>
                                <li>

                                    <Link to="/about">About</Link>


                                </li>
                                <li>

                                    <Link to="/faq">FAQ</Link>


                                </li>
                            </ul>
                            <div className="header-trigger-wrapper d-flex d-lg-none align-items-center">
                                <div className="header-trigger">
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="body-wrapper-inner d-flex flex-wrap pe-lg-0">
                    <div className="body-wrapper-inner__left position-relative pt-80">
                        <h5 style={{
                            fontFamily: 'ahsing',
                            fontSize: '80px',
                            margin: '0',
                            fontWeight: '700',
                            lineHeight: '1.3'
                        }}
                            className="title text--warning mb-4 pb-2" >DAPOK</h5>
                        <p className="mb-4 pb-3" style={{
                            fontFamily: 'Inter',
                        }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                            ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                            voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                        <div className="d-flex flex-wrap gap-3 gap-sm-4">

                            <button className="btn btn--outline-accent" data-bs-target="#accountModal" data-bs-toggle="modal" data-bs-dismiss="modal">Sign In</button>

                            <button className="btn btn--accent" data-bs-toggle="modal" data-bs-target="#accountModal2">Create Account</button>
                        </div>


                        <ul className="social-links d-flex flex-wrap pt-100 gap-3">
                            <li><a href="#!"><img className="mw-100" src="assets/images/icon/facebook.png" alt="icon" /></a></li>
                            <li><a href="#!"><img className="mw-100" src="assets/images/icon/twitter.png" alt="icon" /></a></li>
                            <li><a href="#!"><img className="mw-100" src="assets/images/icon/instagram.png" alt="icon" /></a></li>
                            <li><a href="#!"><img className="mw-100" src="assets/images/icon/gmail.png" alt="icon" /></a></li>
                        </ul>
                    </div>
                    <div className="body-wrapper-inner__right text-end align-self-end">
                        <img src="assets/images/thumb/home.png" alt="thumb" className="mw-100" />
                    </div>
                </div>
            </div>




            <div className="modal fade" id="accountModal" tabIndex="-1" aria-labelledby="accountModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content border-0">
                        <div className="modal-body p-0 ">
                            <div className="account-wrapper d-flex">
                                <div className="account-wrapper__left bg--accent">
                                    <img src="assets/images/thumb/login.png" alt="thumb" className="mw-100" />
                                </div>
                                <div className="account-wrapper__right">
                                    <form onSubmit={handleSubmit2}>
                                        <div className="form-group mb-3 mb-xl-4">
                                            <label className="form-label" htmlFor="">Email</label>
                                            <input type="text" id='email' className="form-control form--control" onChange={e => setEmail(e.target.value)} />
                                        </div>
                                        <div className="form-group mb-3 mb-xl-4">
                                            <label className="form-label" htmlFor="">Password</label>
                                            <input type="password" id='password' className="form-control form--control" onChange={e => setPassword(e.target.value)} />
                                        </div>
                                        <div className="d-flex flex-wrap gap-2 justify-content-between">
                                            <div className="form-group custom--checkbox">
                                                <input type="checkbox" id="rem" />
                                                <label htmlFor="rem">Remember Password</label>
                                            </div>
                                            <a href="/#" className="text--base">Forgot Password?</a>
                                        </div>
                                        <div>
                                            {
                                                validationError2 && <div className="text-center mt-3 mt-sm-4" >
                                                    {validationError2}
                                                </div>
                                            }
                                            {
                                                error2 && <div className="text-center mt-3 mt-sm-4" >
                                                    {error2}
                                                </div>
                                            }
                                        </div>
                                        <div className="text-center mt-4 mt-xl-5">
                                            <button type="submit" className="btn btn--accent">Sign in</button>
                                        </div>
                                        <p className="text-center mt-4 mt-xl-5 mb-0">Don’t have an account?
                                            <button type="button"
                                                className="text--base fw-bold bg-transparent border-0" data-bs-toggle="modal"
                                                data-bs-target="#accountModal2"
                                                data-bs-dismiss="modal">Sign Up.</button></p>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="modal fade pt-50 pb-50" id="accountModal2" tabIndex="-1" aria-labelledby="accountModal2" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content border-0">
                        <div className="modal-body p-0 ">
                            <div className="account-wrapper d-flex">
                                <div className="account-wrapper__left">
                                    <div className="login-thumb">
                                        <img src="assets/images/thumb/sign-up.png" alt="thumb" />
                                        <div className="thumb-content">
                                            <h2 className="title mb-1 text-white">Create an Account</h2>
                                            <p className="pb-40 text-white">Please enter your details to sign up and be part of our community</p>
                                            <p className="text-white">Already have an account? <button type="button" data-bs-toggle="modal" data-bs-target="#accountModal" className="text--base fw-bold border-0 bg-transparent">Sign In</button></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="account-wrapper__right">
                                    <form onSubmit={handleSubmit}>
                                        <div className="tab">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <label className="form-label" >First Name</label>
                                                        <input type="text" className="form-control form--control" onChange={e => setFirstname(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <label className="form-label">Last Name</label>
                                                        <input type="text" className="form-control form--control" onChange={e => setLastname(e.target.value)} />
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="form-group mb-3">
                                                        <label className="form-label" >Email</label>
                                                        <input type="email" className="form-control form--control" id='email' onChange={e => setEmail(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="form-group mb-3">
                                                        <label className="form-label" >Password</label>
                                                        <input type="password" className="form-control form--control" id='password' onChange={e => setPassword(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div>
                                                    {
                                                        validationError && <div className="text-center mt-3 mt-sm-4" >
                                                            {validationError}
                                                        </div>
                                                    }
                                                    {
                                                        error && <div className="text-center mt-3 mt-sm-4" >
                                                            {error}
                                                        </div>
                                                    }
                                                </div>
                                                <div className="col-12">
                                                    <div className="text-center mt-3 mt-sm-4">
                                                        <button type="submit" className="btn btn--accent"

                                                            data-bs-target="#accountModal3" data-bs-dismiss="modal"
                                                            data-bs-toggle="modal"

                                                        >Sign up</button>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>


                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade pt-50 pb-50" id="accountModal3" tabIndex="-1" aria-labelledby="accountModal3" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content border-0">
                        <div className="modal-body p-0 ">
                            <div className="account-wrapper d-flex">
                                <div className="account-wrapper__left">
                                    <div className="login-thumb">
                                        <img src="assets/images/thumb/sign-up.png" alt="thumb" />
                                        <div className="thumb-content">
                                            <h2 className="title mb-1 text-white">Create an Account</h2>
                                            <p className="pb-40 text-white">Please enter your details to sign up and be part of our community</p>
                                            <p className="text-white">Already have an account? <button type="button" data-bs-toggle="modal" data-bs-target="#accountModal" className="text--base fw-bold border-0 bg-transparent">Sign In</button></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="account-wrapper__right">
                                    <form onSubmit={handleSubmit3}>
                                        <div className="tab">
                                            <div className="form-header text-center">
                                                <h4 className="title">Additional Information</h4>
                                                <p className="mb-4">Please fill up the details to continue</p>
                                            </div>
                                            <div className="form-group mb-5 pt-3">
                                                <label htmlFor="for1" className="form-label">Highest Educational Attainment</label>
                                                <select id="for1" className="w-100" onChange={e => setEduc(e.target.value)}>
                                                    <option value="No schooling">No schooling</option>
                                                    <option value="Elementary graduate">Elementary graduate</option>
                                                    <option value="Junior high school graduate">Junior high school graduate</option>
                                                    <option value="Senior high school graduate">Senior high school graduate</option>
                                                    <option value="College undergraduate">College undergraduate</option>
                                                    <option value="Bachelor’s degree">Bachelor’s degree</option>
                                                    <option value="Master’s degree">Master’s degree</option>
                                                    <option value="Doctoral degree">Doctoral degree</option>
                                                </select>
                                            </div>
                                            <div className="form-group mb-5 pt-3">
                                                <label htmlFor="for2" className="form-label">What Language(s) do you speak?</label>
                                                <select id="for2" className="w-100" onChange={e => setLanguage(e.target.value)}>
                                                    <option value="Filipino">Filipino</option>
                                                    <option value="Cebuano">Cebuano</option>
                                                    <option value="Mandaya">Mandaya</option>
                                                </select>
                                            </div>
                                            <div className="form-group mb-5 pt-3">
                                                <label htmlFor="for3" className="form-label">How fluent are you in speaking the Language(s)?</label>
                                                <select id="for3" className="w-100" onChange={e => setFluency(e.target.value)}>
                                                    <option value="Beginner">Beginner</option>
                                                    <option value="Elementary">Elementary</option>
                                                    <option value="Intermediate">Intermediate</option>
                                                    <option value="Advanced">Advanced</option>
                                                </select>
                                            </div>
                                            <div className="text-center mt-5 pt-4">
                                                <button type="submit" data-bs-toggle="modal" data-bs-target="#saveModal" data-bs-dismiss="modal" className="btn btn--accent">Sign Up</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="saveModal" tabIndex="-1" aria-labelledby="saveModal" aria-hidden="true" data-bs-dismiss="modal" onClick={handleClick}>
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content border-0 bg-transparent">
                        <div className="modal-body">
                            <div className="success-message text-center">
                                <img src="assets/images/icon/arrow.png" alt="" className="icon mw-100" />
                                <p className="text">Your account have been created successfully!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>








            <script src="assets/js/lib/jquery-3.6.0.min.js"></script>
            <script src="assets/js/lib/bootstrap.min.js"></script>
            <script src="assets/js/main.js"></script>
        </React.Fragment>

    )
}



